import { DependencyContainer } from './DependencyContainer';

export interface ITypedEvent<T> {
    Subscribe(handler: { (data: T): void }): void;
    Unsubscribe(handler: { (data: T): void }): void;
}

export class TypedEvent<T> implements ITypedEvent<T> {
    private handlers: { (data: T): void; }[] = [];

    public Subscribe(handler: { (data: T): void }): void {
        if (!this.handlers.includes(handler))
            this.handlers.push(handler);
    }

    public Unsubscribe(handler: { (data: T): void }): void {
        this.handlers = this.handlers.filter(h => h !== handler);
    }

    public Invoke(data: T) {
        this.handlers.slice(0).forEach(h => {
            try {
                h(data);
            }
            catch (ex: any) {
                DependencyContainer.Log?.Error(ex);
            }
        });
    }
}
